import {fetchApi} from "../fetch";
import {API_URL} from "../../constants/axios";

export const getMain = async (startDate, endDate) => {
    const searchParam = new URLSearchParams({
        startDate, endDate
    });

    const res = await fetchApi.get(API_URL.DASHBOARD_MAIN + "?" + searchParam.toString())
    if (res.status === 200) {
        return res.data
    } else {
        return {}
    }
}